// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding-top: 32px;
    padding-bottom: 32px;
}

.hero-left hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #15161d;
    margin: 0 0 1rem 0;
    padding: 0;
}

.left-bar {
    padding-right: 25px;
}

.list-group-item {
    padding: 0 0 10px 0;
    padding: 10px;
    transition: 0.2s;
}

.list-group-item:hover {
        background-color: rgba(236, 236, 236, .3);
        box-shadow: 0px 0px 2px rgba(0,0,0,.3);
        border-radius: 0;
        
    }

.list-group-item a {
    text-decoration: none;
}

.job-advert-title {
    color: #326db8;
    font-weight: 600;
}

.job-advert-details {
    color: #909090;
}

.job-advert img {
    margin-top: 8px;
    width: 30px;
    height: 30px;
}

.jobs-see-more {
    background-color: #15161D;
    color: #8D99AE;
    -ms-opacity: .8;
    opacity: .8;
    vertical-align: middle;
    text-align: center;
    font-weight: 400;
    line-height: 1.3;
    border-radius: 0;
    margin-top: 3px;
    transition: 0.2s;
}


    .jobs-see-more:hover, .jobs-see-more:focus {
        color: #EDF2F4;
        text-decoration: none;
        cursor: pointer;
        opacity: 0.9;
    }

.list-group-item {
    background: transparent;
    line-height: 1.2;
    font-size: 14px;
    border: none;
}

.dashbored-center-container {
    -ms-background-size: cover;
    background-size: cover;
    height:656px;
    padding: 20px;
    -ms-opacity: 0.85;
    opacity: 0.85;
}

.absolute {
    position: absolute;
    color: #000;
    margin: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 1;
    top: 15%;
}

.percentage {
    position: relative;
    font-size: xx-large;
    top: -90px;
    left: -130px;
}

.improve-skills {
    position: absolute;
    bottom: 20px;
    line-height: 1.2;
    padding: 12px;
    letter-spacing: 0px;
    color: #fff;;
    opacity: 1;
}

    .improve-skills p {
        font-size: 1.2rem;
    }

    .improve-skills a {
        color: #fff;
        cursor: pointer;
        position: relative;
        z-index: 10;
    }

    .improve-skills a:hover {
        text-decoration: none;
        color: #CCC;
        transition: all 0.1s ease-in;
    }

    .improve-skills.not-complete {
        position: absolute;
        bottom: 20px;
        left: 20px;
    }

    .improve-skills.complete {
        position: absolute;
        bottom: 10px;
        color: #fff;
    }

#tiles {
    margin-top: -14px;
    padding-left: 30px;
}

#tiles a:hover {
    text-decoration: none;
}

.tile {
    height: 200px;
    margin: 0.8rem 0;
    text-align: center;
    padding: 1rem 1rem;
    font-size: 0.8rem;
    color: #fff;
}

    .tile:hover {
        -ms-opacity: 0.9;
        opacity: 0.9;
        transition: all 0.2s ease-in;
    }

    .tile:active {
        transform: translateY(3px);
        transition: 0.1s;
    }

.tile p {
    letter-spacing: 0px;
    font-size: 14px;
    line-height: 1.2;
}

.tile h6 {
    margin-top: 20px;
    margin-bottom: 10px;
}

#profile-link {
    text-decoration: underline;
}

.tile p.tile-h4 {
    font-size: 24px;
    margin-top: 0px;
    margin-bottom: 8px;
    font-weight: 700;
    padding: 0px;
}

@media (max-width: 992px) {    
    #tiles {
        order: 1;
        padding: 0 20px;
    }
    
    #profile {
        order: 2;
        margin-top: 10px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .live-jobs {
        border: 2px solid var(--main-color);
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .improve-skills.complete {
        background-color: rgba(240, 240, 240, 0.8);
        padding-bottom: 0;
        margin: 0 auto;
    }

    .latest-jobs {
        display: none;
    }

    .tile h4 {
        font-size: 19px;
        line-height: 26px;
    }

    .tile p {
        font-size: 16px;
        line-height: 22px;
    }

    #opaque-bg p {
        font-size: 19px;
        font-weight: bold;
    }

    #opaque-bg a {
        font-size: 16px;
        line-height: 22px;
        font-weight: 300;
    }
}

@media (min-width: 768px) and (max-width: 1200px) {
    .job-advert img, .improve img {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IAIb,gBAAgB;AACpB;;AAEA;QACQ,yCAAyC;QACzC,sCAAsC;QAEtC,gBAAgB;;IAEpB;;AAEJ;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAEhB,gBAAgB;IAChB,eAAe;IAIf,gBAAgB;AACpB;;;IAGI;QACI,cAAc;QACd,qBAAqB;QACrB,eAAe;QACf,YAAY;IAChB;;AAEJ;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IAII,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,WAAW;QAIX,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;AAEJ;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;IAEI;QACI,gBAAgB;QAChB,YAAY;QAIZ,4BAA4B;IAChC;;IAEA;QAGI,0BAA0B;QAC1B,gBAAgB;IACpB;;AAEJ;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mCAAmC;QAEnC,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,0CAA0C;QAC1C,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container {\r\n    padding-top: 32px;\r\n    padding-bottom: 32px;\r\n}\r\n\r\n.hero-left hr {\r\n    display: block;\r\n    height: 1px;\r\n    border: 0;\r\n    border-top: 1px solid #15161d;\r\n    margin: 0 0 1rem 0;\r\n    padding: 0;\r\n}\r\n\r\n.left-bar {\r\n    padding-right: 25px;\r\n}\r\n\r\n.list-group-item {\r\n    padding: 0 0 10px 0;\r\n    padding: 10px;\r\n    -ms-transition: 0.2s;\r\n    -o-transition: 0.2s;\r\n    -webkit-transition: 0.2s;\r\n    transition: 0.2s;\r\n}\r\n\r\n.list-group-item:hover {\r\n        background-color: rgba(236, 236, 236, .3);\r\n        box-shadow: 0px 0px 2px rgba(0,0,0,.3);\r\n        -ms-border-radius: 0;\r\n        border-radius: 0;\r\n        \r\n    }\r\n\r\n.list-group-item a {\r\n    text-decoration: none;\r\n}\r\n\r\n.job-advert-title {\r\n    color: #326db8;\r\n    font-weight: 600;\r\n}\r\n\r\n.job-advert-details {\r\n    color: #909090;\r\n}\r\n\r\n.job-advert img {\r\n    margin-top: 8px;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.jobs-see-more {\r\n    background-color: #15161D;\r\n    color: #8D99AE;\r\n    -ms-opacity: .8;\r\n    opacity: .8;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    font-weight: 400;\r\n    line-height: 1.3;\r\n    -ms-border-radius: 0;\r\n    border-radius: 0;\r\n    margin-top: 3px;\r\n    -ms-transition: 0.2s;\r\n    -o-transition: 0.2s;\r\n    -webkit-transition: 0.2s;\r\n    transition: 0.2s;\r\n}\r\n\r\n\r\n    .jobs-see-more:hover, .jobs-see-more:focus {\r\n        color: #EDF2F4;\r\n        text-decoration: none;\r\n        cursor: pointer;\r\n        opacity: 0.9;\r\n    }\r\n\r\n.list-group-item {\r\n    background: transparent;\r\n    line-height: 1.2;\r\n    font-size: 14px;\r\n    border: none;\r\n}\r\n\r\n.dashbored-center-container {\r\n    -webkit-background-size: cover;\r\n    -moz-background-size: cover;\r\n    -o-background-size: cover;\r\n    -ms-background-size: cover;\r\n    background-size: cover;\r\n    height:656px;\r\n    padding: 20px;\r\n    -ms-opacity: 0.85;\r\n    opacity: 0.85;\r\n}\r\n\r\n.absolute {\r\n    position: absolute;\r\n    color: #000;\r\n    margin: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    z-index: 1;\r\n    top: 15%;\r\n}\r\n\r\n.percentage {\r\n    position: relative;\r\n    font-size: xx-large;\r\n    top: -90px;\r\n    left: -130px;\r\n}\r\n\r\n.improve-skills {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    line-height: 1.2;\r\n    padding: 12px;\r\n    letter-spacing: 0px;\r\n    color: #fff;;\r\n    opacity: 1;\r\n}\r\n\r\n    .improve-skills p {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .improve-skills a {\r\n        color: #fff;\r\n        cursor: pointer;\r\n        position: relative;\r\n        z-index: 10;\r\n    }\r\n\r\n    .improve-skills a:hover {\r\n        text-decoration: none;\r\n        color: #CCC;\r\n        -ms-transition: all 0.1s ease-in;\r\n        -o-transition: all 0.1s ease-in;\r\n        -webkit-transition: all 0.1s ease-in;\r\n        transition: all 0.1s ease-in;\r\n    }\r\n\r\n    .improve-skills.not-complete {\r\n        position: absolute;\r\n        bottom: 20px;\r\n        left: 20px;\r\n    }\r\n\r\n    .improve-skills.complete {\r\n        position: absolute;\r\n        bottom: 10px;\r\n        color: #fff;\r\n    }\r\n\r\n#tiles {\r\n    margin-top: -14px;\r\n    padding-left: 30px;\r\n}\r\n\r\n#tiles a:hover {\r\n    text-decoration: none;\r\n}\r\n\r\n.tile {\r\n    height: 200px;\r\n    margin: 0.8rem 0;\r\n    text-align: center;\r\n    padding: 1rem 1rem;\r\n    font-size: 0.8rem;\r\n    color: #fff;\r\n}\r\n\r\n    .tile:hover {\r\n        -ms-opacity: 0.9;\r\n        opacity: 0.9;\r\n        -ms-transition: all 0.2s ease-in;\r\n        -o-transition: all 0.2s ease-in;\r\n        -webkit-transition: all 0.2s ease-in;\r\n        transition: all 0.2s ease-in;\r\n    }\r\n\r\n    .tile:active {\r\n        -ms-transform: translateY(3px);\r\n        -webkit-transform: translateY(3px);\r\n        transform: translateY(3px);\r\n        transition: 0.1s;\r\n    }\r\n\r\n.tile p {\r\n    letter-spacing: 0px;\r\n    font-size: 14px;\r\n    line-height: 1.2;\r\n}\r\n\r\n.tile h6 {\r\n    margin-top: 20px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#profile-link {\r\n    text-decoration: underline;\r\n}\r\n\r\n.tile p.tile-h4 {\r\n    font-size: 24px;\r\n    margin-top: 0px;\r\n    margin-bottom: 8px;\r\n    font-weight: 700;\r\n    padding: 0px;\r\n}\r\n\r\n@media (max-width: 992px) {    \r\n    #tiles {\r\n        order: 1;\r\n        padding: 0 20px;\r\n    }\r\n    \r\n    #profile {\r\n        order: 2;\r\n        margin-top: 10px;\r\n        margin-left: 20px;\r\n        margin-right: 20px;\r\n    }\r\n\r\n    .live-jobs {\r\n        border: 2px solid var(--main-color);\r\n        -ms-border-radius: 5px;\r\n        border-radius: 5px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .improve-skills.complete {\r\n        background-color: rgba(240, 240, 240, 0.8);\r\n        padding-bottom: 0;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .latest-jobs {\r\n        display: none;\r\n    }\r\n\r\n    .tile h4 {\r\n        font-size: 19px;\r\n        line-height: 26px;\r\n    }\r\n\r\n    .tile p {\r\n        font-size: 16px;\r\n        line-height: 22px;\r\n    }\r\n\r\n    #opaque-bg p {\r\n        font-size: 19px;\r\n        font-weight: bold;\r\n    }\r\n\r\n    #opaque-bg a {\r\n        font-size: 16px;\r\n        line-height: 22px;\r\n        font-weight: 300;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1200px) {\r\n    .job-advert img, .improve img {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
